export default "__VITE_ASSET__NTi1YUO3__"